import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgESim = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 36 36"
      aria-hidden="true"
      {...props}
    >
      <circle cx={18} cy={18} r={18} fill="#dbede5" />
      <path
        fill="#fefefe"
        stroke="#003e2b"
        strokeWidth={0.5}
        d="m9.22 6.31 11.72-1.5c.35-.04.6.06.9.29l3.23 2.53c.26.2.4.42.47.77l2.6 20.18q-.01.44-.25.67t-.67.3l-14.93 1.9c-.46-.02-.82-.31-.88-.75L8.37 7.17c.06-.46.4-.8.85-.86Z"
      />
      <path
        fill="#003e2b"
        d="m24.3 27.59-9.38 1.2c-.95.13-1.9-.45-2.03-1.42l-1.2-9.05c-.12-.94.47-1.94 1.49-2.07L22.69 15c.95-.12 1.89.51 2 1.46l1.2 9.26c.11.93-.66 1.74-1.59 1.86"
      />
      <path
        fill="#a6c9be"
        d="m15.61 20.6.46 3.53 5.9-.76-.45-3.53zm-.81-1.52q-.17-.17-.4-.15l-2.16.28-.17-1.26c0-.58.37-1.1.97-1.28l3.45-.44.48 3.77-.74.1zm-.1 9.34c-.64.08-1.22-.27-1.38-.91-.1-.42-.1-.84-.18-1.28l2.14-.28 1.19-1.6q.32-.05.65-.07l.48 3.77zm7.66-10.52a.5.5 0 0 0-.33.2l-1.08 1.39q-.35.07-.73.1l-.49-3.78 3.28-.42c.63 0 1.12.43 1.25 1.04l.16 1.2zm3.11 7.99c.03.66-.45 1.2-1.1 1.29l-2.44.3-.68.1-.5-3.77q.36-.07.7-.09l1.62 1.22 2.25-.27c.04.4.12.79.15 1.22m-5.04-2-2.97.38.48 3.73 2.97-.38zm-.96-8.04-2.68.34.49 3.78 2.67-.34z"
      />
      <path
        fill="#a6c9be"
        d="m15.93 24.66-.77.94-2.06.26-.39-2.95 2.69-.35.24 1.8c.04.14.15.2.29.3m7.26-.06-.96-.77q.2-.17.17-.38l-.23-1.82 2.72-.36.39 3.05zm-1.02-3.32q-.11-.12-.1-.28c0-.47-.08-.9-.16-1.37-.04-.2-.04-.4-.29-.48l.73-.92 2.11-.27.38 2.97zm-7.04-1 .24 1.93-2.7.35-.4-3.09 1.65-.22a1 1 0 0 1 .47-.04l.93.72c-.1.09-.2.19-.19.35"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgESim);
export default Memo;
